module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jamie Sawyer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Jamie Sawyer")]), _vm._v(" was born in 1979 in Newbury, Berkshire. He studied Law at the University of East Anglia, Norwich, acquiring a Master's degree in human rights and surveillance law. Jamie is a full-time barrister, practicing in criminal law. When he isn't working in law or writing, Jamie enjoys spending time with his family in Essex. He is an enthusiastic reader of all types of SF, especially classic authors such as Heinlein and Haldeman.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VXS8fo/tc-custom/9780316411141.jpg?1732162722060",
      "alt": "This image is the cover for the book Eternity War: Exodus, The Eternity War"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Eternity War: Exodus, The Eternity War\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Following "), _c('i', [_vm._v("Pariah")]), _vm._v(" comes "), _c('i', [_vm._v("Exodus")]), _vm._v(", the second book in The Eternity War series -- an explosive tale of elite marines, deep-space exploration and warring galactic empires.")]), _c('br'), _c('br'), _vm._v("Lieutenant Keira Jenkins and her Jackals may have survived confrontations with the Black Spiral terrorist network and a betrayal by one of their own. Yet their troubles are only just beginning."), _c('br'), _c('br'), _vm._v("With their starship badly damaged, they find themselves adrift in hostile territory. Somehow they must find a way to warn the Alliance before the Black Spiral unleashes a new war across the galaxy."), _c('br'), _c('br'), _vm._v("But first they must face the Alliance's oldest enemy: the Asiatic Directorate. And the Directorate has a score to settle with Jenkins . . .\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Orbit\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0